import {
  createCompanyConverter,
  createCompanyConfigConverter,
} from "@t3/shared";
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  serverTimestamp,
} from "firebase/firestore";
import { CompanyType, CompanyConfig } from "@t3/shared";

export const companyConverter = createCompanyConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<CompanyType, DocumentData>;

export const companyConfigConverter = createCompanyConfigConverter<
  DocumentData,
  QueryDocumentSnapshot
>(serverTimestamp) as FirestoreDataConverter<CompanyConfig, DocumentData>;
